import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/loader.svg'


const _hoisted_1 = {
  key: 0,
  class: "min-h-screen bg-gray-100 relative flex flex-col items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-container\"><div class=\"set1\"><div class=\"ball\"></div><div class=\"ball\"></div></div><div class=\"set2\"><div class=\"ball\"></div><div class=\"ball\"></div></div></div><p class=\"text-sm font-semibold\"> Please wait </p>", 2)
const _hoisted_4 = {
  key: 1,
  class: "min-h-screen pt-[62px] sm:pt-[84px] bg-gray-50 relative"
}
const _hoisted_5 = { class: "xs:container mx-auto px-4 relative min-h-fit pb-16" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("section", { class: "w-full mt-8 mb-8 md:mt-14 relative" }, null, -1)
const _hoisted_7 = { class: "w-full relative flex flex-wrap flex-col-reverse lg:flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold uppercase text-xl mb-10" }, " How we do it ", -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "do-it-list block w-full float-left relative pb-10 md:pb-20 before:content-[''] before:border-[1px] before:aa-client-border before:border-dashed before:w-[2px] before:h-full before:absolute before:left-[27px] before:top-[50px]" }
const _hoisted_11 = { class: "float-left w-[calc(100%_-_5.5rem)] max-w-[330px] flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " Give your consent so that we access your details registered with your bank accounts. ", -1)
const _hoisted_13 = { class: "do-it-list block w-full float-left relative pb-10 md:pb-20 before:content-[''] before:border-[1px] before:aa-client-border before:border-dashed before:w-[2px] before:h-full before:absolute before:left-[27px] before:top-[50px]" }
const _hoisted_14 = { class: "float-left w-[calc(100%_-_5.5rem)] max-w-[330px] flex flex-col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " We fetch the information registered with the bank accounts for which you consented. ", -1)
const _hoisted_16 = { class: "do-it-list block w-full float-left relative" }
const _hoisted_17 = { class: "float-left w-[calc(100%_-_5.5rem)] max-w-[330px] flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " We ask you to confirm that fetched information is correct and accurate. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold uppercase text-xl mb-10" }, " Is this Safe? ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " RBI, India's Central Bank and top regulatory body, designed this process of data sharing with user consent, so that you can leverage your information available with banks to avail new services with ease & safety. ", -1)
const _hoisted_21 = { class: "w-full lg:w-1/2 lg:pl-8 xl:pl-32 mb-6 lg:mb-0" }
const _hoisted_22 = { class: "flex items-start justify-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold uppercase text-xl mb-5 sm:mb-10 w-[calc(100%-85px)] sm:w-[calc(100%-120px)]" }, " Account Aggregator Login ", -1)
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight mb-5 sm:mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Enter your AA handle. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" If you don't have one, don't worry. We'll create it for you. ")
], -1)
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "flex flex-row w-full mb-5 sm:mb-10" }
const _hoisted_28 = { class: "w-full relative" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "absolute text-base text-gray-500 text-opacity-50 top-3 left-[11px] bg-white px-2 ease-in-out duration-300 whitespace-nowrap" }, "AA handle or mobile no.", -1)
const _hoisted_30 = { class: "min-w-[125px] relative" }
const _hoisted_31 = { class: "flex flex-col w-full relative" }
const _hoisted_32 = {
  key: 0,
  class: "text-sm mb-2 text-center"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" By continuing, you agree to ")
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Continue to login ")
const _hoisted_36 = {
  key: 0,
  src: _imports_0,
  class: "w-10 h-10"
}
const _hoisted_37 = { class: "flex items-center justify-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-[calc(100%-50px)]" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight mb-2" }, " Unable to process your request at the moment "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " Please try again in sometime ")
], -1)
const _hoisted_39 = { class: "flex items-center justify-between" }
const _hoisted_40 = { class: "w-[calc(100%-50px)]" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight mb-2" }, " You have already completed this journey ", -1)
const _hoisted_42 = { class: "text-base !leading-tight" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Please reach out to ")
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" if you feel this is in error ")
const _hoisted_46 = { class: "flex items-center justify-between" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "w-[calc(100%-50px)]" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight mb-2" }, " Request already processing "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-base !leading-tight" }, " Please try again in sometime ")
], -1)
const _hoisted_48 = { class: "flex flex-col" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold uppercase text-xl mb-5" }, " Available Bank(s) ", -1)
const _hoisted_50 = {
  key: 0,
  class: "text-gray-400 text-lg"
}
const _hoisted_51 = {
  key: 1,
  class: "grid grid-cols-4 gap-2.5"
}
const _hoisted_52 = { class: "text-xs text-center break-all" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "top-0 left-0 w-full h-full backdrop-filter backdrop-blur bg-white bg-opacity-20 fixed inset-0" }, null, -1)
const _hoisted_54 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_55 = { class: "flex min-h-full items-center justify-center p-2.5" }
const _hoisted_56 = { class: "px-5 mb-4 w-full flex items-center justify-between" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, " Terms and Conditions ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 w-full space-y-2.5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2.5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Notice :"),
    /*#__PURE__*/_createTextVNode(" The personal information collected from you vide account statement shall be used for the application processing, claims payout, servicing request, verification by PMLI / Its vendors / partners / reinsurers and investigators. Your personal data will be stored by us for a period prescribed by the applicable law /regulations from time to time. If you have any concerns around the sharing / storing or transferring of your personal data you can write to us anytime to our grievance redressal officer on "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "mailto:indiaservice@pnbmetlife.co.in",
      class: "text-blue-400 underline hover:text-blue-600 cursor-pointer"
    }, "indiaservice@pnbmetlife.co.in")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Consent :"),
    /*#__PURE__*/_createTextVNode(" I hereby consent to share /store my personal data for a period prescribed by the applicable law / regulations from time to time by PMLI / Its vendors / partners / reinsurers and investigators for the application processing, claims payout, servicing request, verification. I am convinced about the accuracy of my personal data shared with the company and I understand the services by PMLI and usages of my personal data.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")!
  const _component_Header = _resolveComponent("Header")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading || _ctx.pageProcessing || _ctx.viewError.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.viewError.status && !(_ctx.loading || _ctx.pageProcessing))
            ? (_openBlock(), _createBlock(_component_error_block, {
                key: 0,
                code: _ctx.viewError.code,
                message: _ctx.viewError.message
              }, null, 8, ["code", "message"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_2
              ], 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.brandLogo === '')
            ? (_openBlock(), _createBlock(_component_Header, {
                key: 0,
                "img-src": require('@/assets/finarkein-logo.svg'),
                "alt-name": "Finarkein Analytics"
              }, null, 8, ["img-src"]))
            : (_openBlock(), _createBlock(_component_Header, {
                key: 1,
                "img-src": _ctx.brandLogo,
                "alt-name": _ctx.orgName
              }, null, 8, ["img-src", "alt-name"])),
          _createElementVNode("div", {
            class: _normalizeClass(["w-full h-80 absolute top-0", [_ctx.brandColor ? 'aa-client-bg' : 'bg-blue-900']])
          }, null, 2),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-full lg:w-1/2 lg:pr-8 xl:pr-32 border-t-2 lg:border-0 lg:border-r-2 pt-12 lg:pt-0", [_ctx.brandColor ? 'aa-client-border' : 'border-blue-900']])
              }, [
                _createVNode(_component_CardItem, { class: "mb-6 p-4 md:p-8 lg:p-10" }, {
                  cardItemBody: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("ul", _hoisted_9, [
                      _createElementVNode("li", _hoisted_10, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-left flex items-center justify-center w-14 h-14 rounded-full text-3xl text-white font-bold mr-5 xs:mr-8 mt-1 relative", [_ctx.brandColor ? 'aa-client-bg' : 'bg-blue-900']])
                        }, "1", 2),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["text-xl mb-1 font-semibold mb-2.5", [_ctx.brandColor ? 'aa-client-color' : 'text-blue-900']])
                          }, " Consent ", 2),
                          _hoisted_12
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_13, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-left flex items-center justify-center w-14 h-14 rounded-full text-3xl text-white font-bold mr-5 xs:mr-8 mt-1 relative", [_ctx.brandColor ? 'aa-client-bg' : 'bg-blue-900']])
                        }, "2", 2),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["text-xl mb-1 font-semibold mb-2.5", [_ctx.brandColor ? 'aa-client-color' : 'text-blue-900']])
                          }, " Access ", 2),
                          _hoisted_15
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_16, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-left flex items-center justify-center w-14 h-14 rounded-full text-3xl text-white font-bold mr-5 xs:mr-8 mt-1 relative", [_ctx.brandColor ? 'aa-client-bg' : 'bg-blue-900']])
                        }, "3", 2),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["text-xl mb-1 font-semibold mb-2.5", [_ctx.brandColor ? 'aa-client-color' : 'text-blue-900']])
                          }, " Verify ", 2),
                          _hoisted_18
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CardItem, { class: "mb-12 p-4 md:p-8 lg:p-10" }, {
                  cardItemBody: _withCtx(() => [
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_CardItem, {
                  class: "mb-6 p-4 md:p-8 lg:p-10",
                  style: {"overflow":"inherit"}
                }, {
                  cardItemBody: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      (_ctx.aaSelected.logo && _ctx.checkAaLogo(_ctx.aaSelected.logo) === true)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.aaSelected.logo,
                            class: "w-[70px] w-[100px]"
                          }, null, 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mobileNumber) = $event)),
                            type: "text",
                            placeholder: "AA handle or mobile no.",
                            disabled: "",
                            class: "placeholder-gray-500 placeholder-opacity-0 focus:placeholder-opacity-50 w-full outline-none py-2 pl-[18px] pr-[18px] text-base rounded-l-lg border focus:aa-client-border h-12 bg-transparent relative z-[2]"
                          }, null, 512), [
                            [_vModelText, _ctx.mobileNumber]
                          ]),
                          _hoisted_29
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_Listbox, {
                            modelValue: _ctx.aaSelected,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.aaSelected) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ListboxButton, { class: "outline-none p-2 text-base border border-gray-600 focus:aa-client-border rounded-r-lg w-full h-full text-left flex items-center justify-between" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getAaHandle(_ctx.aaSelected)) + " ", 1),
                                  _createVNode(_component_ChevronDownIcon, { class: "-mr-1 h-4 w-4" })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ListboxOptions, { class: "absolute top-full left-0 w-full border z-[5] bg-white" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aaList, (aa) => {
                                    return (_openBlock(), _createBlock(_component_ListboxOption, {
                                      key: aa.id,
                                      value: aa,
                                      class: "p-2 w-full hover:bg-sky-100 cursor-pointer"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getAaHandle(aa)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.tenantId === 'pnbmetlife')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("span", {
                                class: "cursor-pointer text-blue-400 hover:underline",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pnbTCmodal()))
                              }, "terms and conditions")
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["pt-2 pb-3 px-4 flex items-center justify-center h-12 w-full text-base xs:text-xl text-white uppercase rounded-lg", [_ctx.brandColor ? 'aa-client-bg' : 'bg-blue-900']]),
                          disabled: _ctx.disabledContinueBtn,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.processRequest()))
                        }, [
                          _hoisted_35,
                          (_ctx.requestProcessing)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_34)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.processingError.code === '500')
                  ? (_openBlock(), _createBlock(_component_CardItem, {
                      key: 0,
                      class: "mb-6 p-4 bg-red-100"
                    }, {
                      cardItemBody: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_XCircleIcon, { class: "w-10 h-10 text-red-500" }),
                          _hoisted_38
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.processingError.code === '409' && _ctx.processingError.errCode === 'AlreadyCompleted')
                  ? (_openBlock(), _createBlock(_component_CardItem, {
                      key: 1,
                      class: "mb-6 p-4 bg-green-100"
                    }, {
                      cardItemBody: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_CheckCircleIcon, { class: "w-10 h-10 text-green-500" }),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("p", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.supportContactDetail), 1),
                              _hoisted_45
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.processingError.code === '409' && _ctx.processingError.errCode === 'InProcess')
                  ? (_openBlock(), _createBlock(_component_CardItem, {
                      key: 2,
                      class: "mb-6 p-4 bg-yellow-100"
                    }, {
                      cardItemBody: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_ExclamationCircleIcon, { class: "w-10 h-10 text-yellow-500" }),
                          _hoisted_47
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_CardItem, { class: "mb-6 p-4 bg-white" }, {
                  cardItemBody: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      (_ctx.selectedMap.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_50, " No banks available at the moment "))
                        : (_openBlock(), _createElementBlock("ul", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMap, (fip) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: fip.id,
                                class: "flex flex-col items-center justify-start"
                              }, [
                                _createVNode(_component_Image, {
                                  class: "w-[40px] h-[40px] mb-2",
                                  ImgSrc: fip.logo,
                                  AltName: fip.name
                                }, null, 8, ["ImgSrc", "AltName"]),
                                _createElementVNode("p", _hoisted_52, _toDisplayString(fip.name), 1)
                              ]))
                            }), 128))
                          ]))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode(_component_Footer, { class: "absolute bottom-0 left-0" })
        ])),
    _createVNode(_component_TransitionRoot, {
      appear: "",
      show: _ctx.pnbTCDailog,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-[99]"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_DialogPanel, { class: "w-full max-w-[750px] transform overflow-hidden rounded-2xl py-5 bg-white shadow-[0px_0px_10px_#bebebe]" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_XIcon, {
                        class: "w-5 h-5 cursor-pointer",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pnbTCDailog = false))
                      })
                    ]),
                    _hoisted_58
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}